import { useEffect } from 'react'
import ApiSuspense from 'src/components/shared/ApiSuspense'
import useAvisosLexnet from 'src/hooks/useAvisosLexnet'
import { AvisoLexnet } from 'src/interfaces'
import { markAsRead as markAsReadRequest } from 'src/services/AvisoLexnetService'
import AvisosLexnetView from './AvisosLexnetView'

function AvisosLexnet(): JSX.Element {
  const query = useAvisosLexnet()

  useEffect(
    function() {
      if (!query.isSuccess) {
        return
      }
      if (!query.data) {
        return
      }
      const avisosLexnet = query.data as AvisoLexnet[]
      avisosLexnet.forEach(avisoLexnet => {
        if (avisoLexnet.isNew) {
          markAsReadRequest(avisoLexnet.id)
        }
      })
    },
    [query]
  )

  return (
    <ApiSuspense queries={query}>
      {() => <AvisosLexnetView avisosLexnet={query.data as AvisoLexnet[]} />}
    </ApiSuspense>
  )
}

export default AvisosLexnet
